module.exports = __webpack_public_path__ + "static/media/trash.e7475536.svg";